import http from './http';

/// Sirket

export function getSirket() {
    return http.get(`/sirket`);
}

export function getSirketDetail(id) {
    return http.get(`/sirket/detail/${id}`);
}

export function sirketAktifEt(id) {
    return http.put(`/sirket/aktif/${id}`);
}

export function sirketPasifEt(id, pasif_notu) {
    return http.put(`/sirket/pasif/${id}`, { pasif_notu });
}

export function createSirket(data) {
    return http.post(`/sirket/create`, data);
}

export function updateSirket(id, data) {
    return http.put(`/sirket/update/${id}`, data);
}

export function deleteSirket(id) {
    return http.delete(`/sirket/delete/${id}`);
}
